
import { defineComponent, ref, computed, PropType } from 'vue'
import Draggable from 'vuedraggable'
import RoutePlace from './RoutePlace.vue'
import { store } from '@/store'

import { validatePlaceIndex } from '@/api/tripply'
import { Route, Place, RouteLiveState } from '@/api/tripply/models'

export default defineComponent({
  name: 'RoutePlaces',
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    },
    places: {
      type: Object as PropType<Place[]>,
      required: true
    },
    liveState: {
      type: [Object, Boolean] as PropType<false | RouteLiveState>,
      required: true
    },
    locked: Boolean
  },
  components: { Draggable, RoutePlace },
  setup(props) {
    const isOwner = computed(() => store.user.isOwner(props.route.id))
    const isDragging = ref(false)

    // Create non-reactive reference
    const placeList = computed(() => [...props.places])

    function checkMove(e: any) {
      const { index, futureIndex } = e.draggedContext
      return validatePlaceIndex(props.route, index, futureIndex)
    }
    function onMove() {
      isDragging.value = true      
    }
    function onMoved(e: any) {
      isDragging.value = false 
      store.route.changePlaceIndex(props.route.id, e.oldIndex, e.newIndex)
    }
    
    function openPlaceImporter() {
      store.modal.showModal('PlaceImporter', {routeId: props.route.id})
    }

    return { placeList, isOwner, props, onMove, checkMove, onMoved, isDragging, openPlaceImporter }
  }
})
